import { render, staticRenderFns } from "./LectureMarksListTopicHeaderPopover.vue?vue&type=template&id=3f1637c0"
import script from "./LectureMarksListTopicHeaderPopover.vue?vue&type=script&lang=js"
export * from "./LectureMarksListTopicHeaderPopover.vue?vue&type=script&lang=js"
import style0 from "./LectureMarksListTopicHeaderPopover.vue?vue&type=style&index=0&id=3f1637c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports